// Static site config — easy to swap content later.
export const BRAND = {
  name: "R Morrison",
  fullName: "Rachel Morrison",
  phone: "0401 592 065",
  email: "rmorrisonmakeup@gmail.com",
  instagram: "https://instagram.com/the.rachel.morrison",
  instagramHandle: "@the.rachel.morrison",
  location: "Melbourne, AU",
};

export const NAV = [
  { to: "/", label: "Home" },
  { to: "/services", label: "Services" },
  { to: "/portfolio", label: "Portfolio" },
  { to: "/about", label: "About" },
  { to: "/vendors", label: "Vendors I Love" },
  { to: "/contact", label: "Contact" },
];

export const PORTFOLIO_CATEGORIES = ["All", "Bridal", "Editorial", "Events", "Hair", "Film & TV"];

export const VENDOR_CATEGORIES = [
  "All",
  "Photographers",
  "Celebrants",
  "Florists",
  "Venues",
  "Stylists",
  "Entertainment",
  "Other Creatives",
];
